import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import {
  OrderDetailsOverviewCard,
  InvoicesCard,
  OrderDetailsCard,
} from "../../components";
import { BackButton } from "../../../../components";
import { getInvoices } from "../../clientDashboardSlice";

import "./ClientOrder.scss";

export function ClientOrder() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const orderId = params.id;
  const order = useAppSelector(
    (state) =>
      state.clientDashboard.activeOrders.find((o) => o.id === orderId) ||
      state.clientDashboard.completedOrders.find((o) => o.id === orderId)
  );

  React.useEffect(() => {
    if (!orderId) return;

    dispatch(
      getInvoices({
        orderId,
      })
    );
  }, []);

  const onBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="client-order-component">
      <div className="back-button-container">
        <BackButton onClick={onBackButtonClick} />
      </div>

      <OrderDetailsOverviewCard />

      <OrderDetailsCard order={order!} />

      <InvoicesCard />
    </div>
  );
}
